import { ExternalDataDTO } from "api/interfaces/external-data-dto";
import { FreedomPayResponseDTO } from "api/interfaces/fp-pay-response-dto";

export const mapFPResponseMapper = (response: FreedomPayResponseDTO, invoiceNumber: string): ExternalDataDTO => {
  const { FreewayResponse } = response;
  const mappedFPResponse: ExternalDataDTO = {
    receiptIdentifier: {
      authorizationCode: FreewayResponse.ccAuthReply.authorizationCode || ""
    },
    transactionIdentifier: {
      localRequestId: invoiceNumber,
      remoteRequestId: FreewayResponse.requestID || "",
      merchantReferenceCode: FreewayResponse.merchantReferenceCode || "",
      authorizationCode: FreewayResponse.ccAuthReply.authorizationCode || "",
      originalTransactionType: "SALE",
      expirationDate: "",
      currentTotalAmount: FreewayResponse.ccCaptureReply.amount || "",
      accountToken: "",
      cardType: ""
    },
    transactionId: FreewayResponse.requestID || ""
  };

  return mappedFPResponse;
};
